const abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'caller',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'vault',
        type: 'address',
      },
    ],
    name: 'CallerIsNotVault',
    type: 'error',
  },
  {
    inputs: [],
    name: 'ContractNotInitialized',
    type: 'error',
  },
  {
    inputs: [],
    name: 'DecodeReinitializeDataFarmZero',
    type: 'error',
  },
  {
    inputs: [],
    name: 'DecodeReinitializeDataUniversalRouterZero',
    type: 'error',
  },
  {
    inputs: [],
    name: 'DepositConvertlessPoolIsInvalid',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'pool',
        type: 'address',
      },
    ],
    name: 'ReinitializeInvalidPID',
    type: 'error',
  },
  {
    inputs: [],
    name: 'ReinitializeOracleZero',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'amount0',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'minAmount0',
        type: 'uint256',
      },
    ],
    name: 'UpdatePriceRangesShiftPercentAmount0LtMin',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'amount1',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'minAmount1',
        type: 'uint256',
      },
    ],
    name: 'UpdatePriceRangesShiftPercentAmount1LtMin',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'caller',
        type: 'address',
      },
    ],
    name: 'UpdatePriceRangesShiftPercentCallerNotAuthorized',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'nativeBalanceVault',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'minNativeBalanceVault',
        type: 'uint256',
      },
    ],
    name: 'UpdatePriceRangesShiftPercentMinNativeBalanceVaultLtMin',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint8',
        name: 'version',
        type: 'uint8',
      },
    ],
    name: 'Initialized',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'low',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'up',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'approxLow',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'approxUp',
        type: 'uint256',
      },
    ],
    name: 'PriceRangesShiftPercentUpdated',
    type: 'event',
  },
  {
    inputs: [],
    name: 'MIN_AMOUNT_OUT',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes',
        name: 'params',
        type: 'bytes',
      },
    ],
    name: 'decodeAndValidateReinitialize',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'nativeAmount',
        type: 'uint256',
      },
    ],
    name: 'deposit',
    outputs: [
      {
        internalType: 'uint256',
        name: 'stakingAmount',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'stakingAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'depositLiquidityAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'feeLiquidityAmount',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'feeRecipient',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'residualsRecipient',
        type: 'address',
      },
    ],
    name: 'depositConvertless',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'dexVersion',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'stakingAmount',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'recipient',
        type: 'address',
      },
    ],
    name: 'emergencyWithdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'farm',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amountIn',
        type: 'uint256',
      },
    ],
    name: 'getAmountOutRewardTokenToNative',
    outputs: [
      {
        internalType: 'uint256',
        name: 'nativeAmount',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'amountIn',
        type: 'uint256',
      },
    ],
    name: 'getAmountOutStakingTokenToNative',
    outputs: [
      {
        internalType: 'uint256',
        name: 'nativeAmount',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'globalUpdate',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'harvest',
    outputs: [
      {
        internalType: 'uint256',
        name: 'nativeAmount',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'harvestDebt',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'debt0',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'debt1',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'debtReward',
            type: 'uint256',
          },
        ],
        internalType: 'struct RewardsManagement.HarvestDebt',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'initializationVersion',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes',
        name: 'params',
        type: 'bytes',
      },
    ],
    name: 'initialize',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'liquidity',
    outputs: [
      {
        internalType: 'uint256',
        name: 'liquidity_',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'lmLiquidity',
    outputs: [
      {
        internalType: 'uint256',
        name: 'lmLiquidity_',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'native',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: '',
        type: 'bytes',
      },
    ],
    name: 'onERC721Received',
    outputs: [
      {
        internalType: 'bytes4',
        name: '',
        type: 'bytes4',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [],
    name: 'oracleData',
    outputs: [
      {
        components: [
          {
            internalType: 'contract INativeV3PriceOracleValidator',
            name: 'oracle',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'acceptableDeviationPool',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'acceptableDeviationSwap',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'lastValidatePriceTimestamp',
            type: 'uint256',
          },
        ],
        internalType: 'struct Oracle.OracleData',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'pendingRewards',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'priceRangesData',
    outputs: [
      {
        components: [
          {
            internalType: 'int24',
            name: 'tickLower',
            type: 'int24',
          },
          {
            internalType: 'int24',
            name: 'tickUpper',
            type: 'int24',
          },
          {
            internalType: 'uint256',
            name: 'sqrtPriceX96Low',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'sqrtPriceX96Up',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'sqrtPriceX96LowLimit',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'sqrtPriceX96UpLimit',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'approxToRangeLimitLowPercent',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'approxToRangeLimitUpPercent',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'deviationPercentLow',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'deviationPercentUp',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'defaultDeviationPercentLow',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'defaultDeviationPercentUp',
            type: 'uint256',
          },
        ],
        internalType: 'struct PriceManagement.PriceRangesData',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes',
        name: 'params',
        type: 'bytes',
      },
    ],
    name: 'reinitialize',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'rewardTokenType',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'rewardTokens',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'rewardTokensCount',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'sharePerTimeUnit',
    outputs: [
      {
        internalType: 'uint256',
        name: 'share',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'stakingToken',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId_',
        type: 'uint256',
      },
    ],
    name: 'stakingTokenApproveData',
    outputs: [
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'stakingTokenData',
    outputs: [
      {
        components: [
          {
            internalType: 'string',
            name: 'stakingTokenType',
            type: 'string',
          },
          {
            internalType: 'contract IPancakeV3Pool',
            name: 'pool',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'token0',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'token1',
            type: 'address',
          },
          {
            internalType: 'uint24',
            name: 'fee',
            type: 'uint24',
          },
        ],
        internalType: 'struct PancakeSwapFarm.StakingTokenData',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'inputTokenId',
        type: 'uint256',
      },
    ],
    name: 'stakingTokenLiquidity',
    outputs: [
      {
        internalType: 'uint256',
        name: 'liquidity_',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId_',
        type: 'uint256',
      },
    ],
    name: 'stakingTokenTransferFromData',
    outputs: [
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'stakingTokenType',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'swapData',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'minSwapAmountNative',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'minSwapAmountToken0',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'minSwapAmountToken1',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'minSwapAmountRewardToken',
            type: 'uint256',
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'tokenIn',
                type: 'address',
              },
              {
                internalType: 'address',
                name: 'tokenOut',
                type: 'address',
              },
            ],
            internalType: 'struct Swap.SwapPair[]',
            name: 'swapsToken0ToNative',
            type: 'tuple[]',
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'tokenIn',
                type: 'address',
              },
              {
                internalType: 'address',
                name: 'tokenOut',
                type: 'address',
              },
            ],
            internalType: 'struct Swap.SwapPair[]',
            name: 'swapsToken1ToNative',
            type: 'tuple[]',
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'tokenIn',
                type: 'address',
              },
              {
                internalType: 'address',
                name: 'tokenOut',
                type: 'address',
              },
            ],
            internalType: 'struct Swap.SwapPair[]',
            name: 'swapsNativeToToken0',
            type: 'tuple[]',
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'tokenIn',
                type: 'address',
              },
              {
                internalType: 'address',
                name: 'tokenOut',
                type: 'address',
              },
            ],
            internalType: 'struct Swap.SwapPair[]',
            name: 'swapsNativeToToken1',
            type: 'tuple[]',
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'tokenIn',
                type: 'address',
              },
              {
                internalType: 'address',
                name: 'tokenOut',
                type: 'address',
              },
            ],
            internalType: 'struct Swap.SwapPair[]',
            name: 'swapsToken0ToToken1',
            type: 'tuple[]',
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'tokenIn',
                type: 'address',
              },
              {
                internalType: 'address',
                name: 'tokenOut',
                type: 'address',
              },
            ],
            internalType: 'struct Swap.SwapPair[]',
            name: 'swapsToken1ToToken0',
            type: 'tuple[]',
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'tokenIn',
                type: 'address',
              },
              {
                internalType: 'address',
                name: 'tokenOut',
                type: 'address',
              },
            ],
            internalType: 'struct Swap.SwapPair[]',
            name: 'swapsRewardTokenToNative',
            type: 'tuple[]',
          },
        ],
        internalType: 'struct Swap.SwapData',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'timeUnit',
    outputs: [
      {
        internalType: 'enum IDexFiFarm.TimeUnit',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [],
    name: 'tokenId',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'universalRouter',
    outputs: [
      {
        internalType: 'contract IDexFiUniversalRouterBytes',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'lowPercent',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'upPercent',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'approxToRangeLowPercent',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'approxToRangeUpPercent',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'minNativeBalanceVault',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'minAmount0',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'minAmount1',
        type: 'uint256',
      },
    ],
    name: 'updatePriceRangesShiftPercent',
    outputs: [
      {
        internalType: 'uint256',
        name: 'nativeBalanceVault',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'amount0',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'amount1',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'vault',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'stakingAmount',
        type: 'uint256',
      },
    ],
    name: 'withdraw',
    outputs: [
      {
        internalType: 'uint256',
        name: 'nativeAmount',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'stakingAmount',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'recipient',
        type: 'address',
      },
    ],
    name: 'withdrawConvertless',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const;

export default abi;
